/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.0.0
 */

import { IPageSubscriberFixedTranslation } from '../../types';

const initTranslationPageSubscriberFixed: IPageSubscriberFixedTranslation = {
    table: {
        account: {
            header: '',
        },
        accountName: {
            header: '',
        },
        address2: {
            header: '',
        },
        address: {
            header: '',
        },
        bzNumber: {
            header: '',
        },
        contractNumber: {
            header: '',
        },
        hide: '',
        inn: {
            header: '',
        },
        kpp: {
            header: '',
        },
        labels: {
            header: '',
        },
        msisdn: {
            header: '',
        },
        productName: {
            header: '',
        },
        subdivisionKpp: {
            header: '',
        },
        subdivisionName: {
            header: '',
        },
    },
    tableFooter: {
        basketTitle: '',
        checkedNum: '',
        disabledButton: {
            maxSize: '',
        },
        linkBalance: {
            title: '',
            tooltip: '',
        },
        linkEdit: {
            title: '',
            tooltip: '',
        },
        linkMessage: {
            title: '',
            tooltip: '',
        },
        linkStatistic: {
            title: '',
            tooltip: '',
        },
    },
    title: {
        dropFilters: '',
        exportBtn: '',
        filterSetting: '',
        header: '',
        tableSetting: {
            applyBtn: '',
            closeBtn: '',
            footnote: '',
            subTitle: '',
            title: '',
            titleBtn: '',
        },
    },
};

export default initTranslationPageSubscriberFixed;
